import React, { createContext, useContext, useMemo } from 'react';
import { createPdfStyles, pdfStyles as defaultPdfStyles } from './pdfTheme';

const PdfPrintScaleContext = createContext(defaultPdfStyles);

/**
 * Supplies scaled {@link createPdfStyles} to PDF template children.
 * @param {{ scale?: number; children: React.ReactNode }} props
 */
export function PdfPrintScaleProvider({ scale = 1, children }) {
    const styles = useMemo(() => createPdfStyles(scale), [scale]);
    return (
        <PdfPrintScaleContext.Provider value={styles}>{children}</PdfPrintScaleContext.Provider>
    );
}

export function usePdfStyles() {
    return useContext(PdfPrintScaleContext);
}
